<template>
  <v-app id="tibava">
    <v-app-bar app>
      <img :title="appName" src="./assets/logo_tib.svg" height="40" />
      <v-toolbar-title style="padding-right: 50px"
        >AV-Analytics</v-toolbar-title
      >

      <v-btn tile text class="ml-n2" to="/">
        <v-icon left color="primary">mdi-movie</v-icon>
        Videos
      </v-btn>
      <v-btn tile text class="ml-n2" to="/batches">
        <v-icon left color="primary">mdi-folder-multiple-video</v-icon>
        Batches
      </v-btn>

      <v-spacer></v-spacer>
      <router-view name="menu" />
    </v-app-bar>
    <router-view />
    <ModalError />
  </v-app>
</template>

<script>
import ModalVideoUpload from "@/components/ModalVideoUpload.vue";
import UserMenu from "@/components/UserMenu.vue";
import VideoMenu from "@/components/VideoMenu.vue";
import AnnotationMenu from "@/components/AnnotationMenu.vue";
import History from "./components/History.vue";
import ModalError from "./components/ModalError.vue";

import { mapStores } from "pinia";
import { useUserStore } from "@/store/user";
import { useVideoStore } from "@/store/video";
import { usePlayerStore } from "@/store/player";
import { useErrorStore } from "@/store/error";

export default {
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
    };
  },
  computed: {
    loggedIn() {
      return this.userStore.loggedIn;
    },

    ...mapStores(useUserStore, usePlayerStore, useErrorStore, useVideoStore),
  },
  components: {
    ModalVideoUpload,
    UserMenu,
    VideoMenu,
    AnnotationMenu,
    History,
    ModalError,
  },
};
</script>

<style>
#tibava {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  /* margin-top: 0px; */
}
</style>
